import React from 'react';
import './Credentials.css';

const tools = [
  'Jira',
  'Confluence',
  'Microsoft Project',
  'Monday.com',
  'ClickUp',
  'Asana',
  'ServiceNow',
  'Slack',
  'MS Teams',
  'Power BI',
  'Trello',
  'Notion',
];

export default function Credentials() {
  return (
    <section className="section credentials anchor" id="credentials">
      <div className="container credentials__inner">
        <div>
          <h2 className="credentials__title">Certifications &amp; Expertise</h2>
          <ul className="credentials__list">
            <li>PMP® - Project Management Professional</li>
            <li>ITIL 4 Foundation - Service Management</li>
            <li>PSM I - Professional Scrum Master</li>
            <li>CompTIA Security+ - IT Security</li>
          </ul>

          <h3 className="credentials__toolsTitle">Tools &amp; Platforms</h3>
          <div className="credentials__tools" aria-label="Tools">
            {tools.map((t) => (
              <span className="credentials__tool" key={t}>
                {t}
              </span>
            ))}
          </div>
        </div>

        <div className="credentials__card">
          <h3>Track Record</h3>
          <ul className="credentials__bullets">
            <li>7+ years delivering projects across Banking, FinTech, and IT services</li>
            <li>Led cross-functional teams through Agile and Waterfall delivery cycles</li>
            <li>Reduced project delays and stabilised incident-prone IT environments</li>
            <li>Implemented ITIL 4 service management frameworks to cut recurring incidents</li>
            <li>Delivered stakeholder-facing reporting across executive and technical audiences</li>
          </ul>

          <div className="credentials__stats" aria-label="Stats">
            <div className="credentials__stat">
              <div className="credentials__statValue">7+ yrs</div>
              <div className="credentials__statLabel">Experience</div>
            </div>
            <div className="credentials__stat">
              <div className="credentials__statValue">4</div>
              <div className="credentials__statLabel">Certifications</div>
            </div>
            <div className="credentials__stat">
              <div className="credentials__statValue">3</div>
              <div className="credentials__statLabel">Industries</div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
